import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiUrlV1 } from "../../../config/config"
import { agent } from "../../../api";
import { handlerNeedUpdateProfiles } from "../coinFlipTableStore";
import { addNotification } from "../../Notification/notificateStore";
import { CoinProfile, CoinProfileGlobalSettings } from "../../../entities/coinGame";

/**
 * Создание профиля игры coin flip
 * 
 * @param {CoinProfileGlobalSettings} data - данные глобальной формы для создания {@link CoinProfileGlobalSettings}
 */
export const postCoinProfile = createAsyncThunk(
  "coin/post-profile",
  async (params: { data: CoinProfileGlobalSettings }, thunksApi): Promise<CoinProfile> => {
    try {
      const v3ProfileBody = {
        ...params.data,
        isSortMode: false,
        isMultiGame:false,
        game: 'coinFlip'
      }
      const response = await agent.post(
        `${apiUrlV1}/v3/organization/game/profile/create/from-global-settings`,
        {
          body: JSON.stringify(v3ProfileBody),
        }
      );
      if (response.ok) {
        const data = await response.json() as CoinProfile;
        thunksApi.dispatch(handlerNeedUpdateProfiles());
        thunksApi.dispatch(
          addNotification({ status: "success", text: "Successfully saved" })
        );
        return data;
      }
      if (!response.ok) {
        const { message } = await response.json() as { message: string }
        thunksApi.dispatch(
          addNotification({ status: "error", text: message })
        );
        throw Error("No response");
      }

      throw Error("No response");
    } catch (error) {
      throw Error("Request is not found");
    }
  }
);
// /v3/organization/game/profile/create/from-global-settings

/**
 * Получение профиля игры по id coin flip
 * 
 * @param {number} id - ID профиля 
 * 
 * @returns {CoinProfile} возвращает профиль игры типа {@link CoinProfile}
 */
export const getCoinProfile = createAsyncThunk(
  "coin/get-profile",
  async (params: { id: number }, thunksApi): Promise<CoinProfile> => {
    try {
      const response = await agent.get(`${apiUrlV1}/v3/organization/game/profile/read/${params.id}`);
      if (response.ok) {
        const data = await response.json() as CoinProfile;
        return data;
      }

      throw Error("No response");
    } catch (error) {
      throw Error("Request is not found");
    }
  }
);

/**
 * Изменение профиля игры coin flip
 * 
 * @param {any} data - данные глобальной формы для создания
 * @param {number} id - id профиля
 * b
 * @returns {CoinProfile} возвращает профиль игры типа {@link CoinProfile}
 */
export const patchCoinProfile = createAsyncThunk(
  "coin/patch-profile",
  async (params: {
    data: {
      globalSettings?: CoinProfileGlobalSettings,
      configuration?: {
        gameEntities: {
          gameEntityId: number,
          index: number,
        }[]
      }
    }, id: number
  }, thunksApi): Promise<CoinProfile> => {
    try {
      const response = await agent.patch(
        `${apiUrlV1}/v3/organization/game/profile/update/from-config-part/${params.id}`,
        {
          body: JSON.stringify(params.data),
        }
      );
      if (response.ok) {
        const data = await response.json() as CoinProfile;
        thunksApi.dispatch(handlerNeedUpdateProfiles());
        thunksApi.dispatch(
          addNotification({ status: "success", text: "Successfully saved" })
        );
        return data;
      }
      if (!response.ok) {
        const data = await response.json() as { message: string[] | string };
        if (typeof (data.message) === 'object' && data.message.length > 0) {
          data.message.forEach(element => {
            thunksApi.dispatch(
              addNotification({ status: "error", text: element })
            );
          });
        }
        if (typeof (data.message) === 'string') {
          thunksApi.dispatch(
            addNotification({ status: "error", text: data.message })
          );
        }
      }

      throw Error("No response");
    } catch (error) {
      throw Error("Request is not found");
    }
  }
);
